import z from 'zod'

function zEnumFromTsEnum<T extends Record<string, string>>(tsEnum: T) {
  const values = Object.values(tsEnum)

  return z.string().refine((val): val is T[keyof T] => values.includes(val), {
    message: `Value must be one of: ${values.join(', ')}`,
  })
}

const ZodHelper = {
  zEnumFromTsEnum,
}

export default ZodHelper
